/**
 * return true if the code is running on the client side (in the browser)
 */
export const IS_CLIENT = import.meta.client;
